import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-global space-y-8" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "flex divide-x" }
const _hoisted_4 = { class: "flex-1 flex-col space-y-6" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_8 = { class: "flex space-x-12" }
const _hoisted_9 = { class: "flex flex-col" }

import BackButton from "@/components/common/BackButton.vue";
import { ref, onMounted, reactive, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Button, SegmentedButtons } from "@/components/common/";
import { Job } from "@/types/";
import { JobDataService } from "@/services/";
import { StatusesEnum } from "@/store";
import { useStore } from "vuex";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { JobActions } from "@/store/modules/job/actions";
import { JobGetters } from "@/store/modules/job/getters";
import { t } from "@/i18n";
import { getCommonStatusOptions } from "@/utils/labels";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const statuses = computed(() => getCommonStatusOptions());

const state = reactive<Job>({
  status: StatusesEnum.ACTIVE,
  name: "",
});
const rules = {
  status: { required },
  name: { required },
};
const $externalResults = ref({});
const submitted = ref(false);
const v$ = useVuelidate(rules, state, { $externalResults });

if (route.name === "JobEdit") {
  onMounted(async () => {
    await store.dispatch(JobActions.FETCH_ONE, route.params.id);
    const job = store.getters[JobGetters.GET_CURRENT];
    state.id = job.id;
    state.status = job.status;
    state.name = job.name;
  });
}

async function handleSubmit(isFormValid: boolean) {
  submitted.value = true;
  if (!isFormValid) {
    return;
  }

  route.name === "JobEdit" ? await updateJob() : await createJob();
}

const createJob = async () => {
  await store
    .dispatch(JobActions.CREATE, state)
    .then(async () => {
      await router.push({ name: "JobList" });
    })
    .catch((error) => {
      $externalResults.value = error.data.data;
    });
};

const updateJob = async () => {
  await store
    .dispatch(JobActions.UPDATE, { id: state.id, data: state })
    .then(async () => {
      await router.push({ name: "JobList" });
    })
    .catch((error) => {
      $externalResults.value = error.data.data;
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'JobList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(route).name === "JobEdit"
          ? _unref(t)("jobForm.titleEdit")
          : _unref(t)("jobForm.titleCreate")), 1),
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", {
                class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).name.$invalid && submitted.value }])
              }, _toDisplayString(_unref(t)("common.title")), 3),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["input-form", {
                'p-invalid': _unref(v$).name.$invalid && submitted.value,
              }]),
                placeholder: _unref(t)('common.placeholderName'),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event))
              }, null, 10, _hoisted_6), [
                [_vModelText, _unref(v$).name.$model]
              ]),
              (_unref(v$).name.$externalResults.length > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(v$).name.$externalResults[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", {
                  class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).status.$invalid && submitted.value }])
                }, _toDisplayString(_unref(t)("common.status")), 3),
                _createVNode(_unref(SegmentedButtons), {
                  class: _normalizeClass(["", {
                  'p-invalid': _unref(v$).status.$invalid && submitted.value,
                }]),
                  options: _unref(statuses),
                  modelValue: _unref(v$).status.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).status.$model) = $event)),
                  required: ""
                }, null, 8, ["class", "options", "modelValue"])
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_unref(Button), { type: "submit" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$route.name === "JobEdit"
                  ? _unref(t)("jobForm.submitUpdate")
                  : _unref(t)("jobForm.submitCreate")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ], 32)
    ])
  ], 64))
}
}

})